import { FC, HTMLAttributes, ReactNode } from "react";
import { clsx } from "clsx";
import classes from "./StatusDot.module.less";

export type StatusDotColor = "grey" | "blue" | "orange" | "green" | "red";

export interface StatusDotProps extends HTMLAttributes<HTMLSpanElement> {
    color: StatusDotColor;
    children: ReactNode;
}

const dotColorClasses: Record<StatusDotColor, string> = {
    grey: classes["status-dot__dot--grey"],
    blue: classes["status-dot__dot--blue"],
    orange: classes["status-dot__dot--orange"],
    green: classes["status-dot__dot--green"],
    red: classes["status-dot__dot--red"],
};

/** A status label preceded by a colored dot. */
export const StatusDot: FC<StatusDotProps> = ({ color, children, className, ...restProps }) => (
    <span className={clsx(classes["status-dot"], className)} {...restProps}>
        <span className={clsx(classes["status-dot__dot"], dotColorClasses[color])} />
        {children}
    </span>
);

StatusDot.displayName = "StatusDot";
